import { MASKS } from '@/shared/constants/phoneMasks.constants'

export const applyPhoneMask = (phone: string, countryCode: string): string => {
  if (!phone || !countryCode) return phone

  const maskData = MASKS[countryCode as keyof typeof MASKS]
  if (!maskData) return phone

  const phoneDigits = phone.replace(/\D/g, '')
  const mask = maskData.mask

  const countryDialCode = mask.substring(0, mask.indexOf('#')).replace(/\D/g, '')
  const digits = phoneDigits.substring(countryDialCode.length)

  let digitIndex = 0
  return mask
    .replace(/./g, (char) => {
      if (char === '#') {
        return digitIndex < digits.length ? digits[digitIndex++] : ''
      }
      return char
    })
    .trim()
}
